import { render, staticRenderFns } from "./ExtraPopover.vue?vue&type=template&id=01024066&scoped=true&"
import script from "./ExtraPopover.vue?vue&type=script&lang=js&"
export * from "./ExtraPopover.vue?vue&type=script&lang=js&"
import style0 from "./ExtraPopover.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ExtraPopover.vue?vue&type=style&index=1&id=01024066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01024066",
  null
  
)

export default component.exports